//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  DatetimePicker,
  Popup,
} from 'vant'
import {
  format,
  formatDate,
  formatTime,
} from '@/utils/date'
import CInput from '../CInput'
import {
  isDate,
  isEmptyAll,
} from '../../utils/validator'

export default {
  name: 'CDate',

  components: {
    DatetimePicker,
    Popup,
    CInput,
  },

  props: {
    ...DatetimePicker.props,
    value: {
      type: [
        String,
        Number,
        Object,
        Date,
      ],
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    precision: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'date',
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    minDate: {
      type: Date,
      default: () => (new Date(new Date().getFullYear() - 60, 0, 1)),
    },

    maxDate: {
      type: Date,
      default: () => (new Date(new Date().getFullYear() + 60, 0, 1)),
    },

  },

  data () {
    return {
      popupVisible: false,
      currentTime: '',
      showName: '',
      currentNameIsEmpty: false,
    }
  },

  computed: {
    rightIcon () {
      return (this.readonly || this.disabled || !this.clearable) ? '' : (this.currentNameIsEmpty ? 'arrow' : 'cross')
    },
  },

  watch: {
    showName (val) {
      this.currentNameIsEmpty = isEmptyAll(val)
    },

    value: {
      immediate: true,
      handler (val) {
        if (isDate(this.value)) {
          this.currentTime = this.value
        } else if (this.value && typeof this.value === 'string') {
          this.currentTime = new Date(this.value.replace(/-/g, '/'))
        }

        this.$emit('input', formatTime(this.currentTime))
        if (!isEmptyAll(this.currentTime)) {
          this.$emit('on-change', this.currentTime, this.options)
        }

        this.showName = this.filterDate(this.currentTime)
      },
    },
  },

  methods: {
    rightIconClick () {
      if (this.currentNameIsEmpty && this.rightIcon === 'arrow') {
        this.showPopup()
      } else if (this.clearable) {
        this.$emit('input', undefined)
      } else {
        this.showPopup()
      }
    },

    onConfirm (val) {
      this.showName = this.filterDate(val)

      this.$emit('input', formatTime(val))
      this.popupVisible = false
    },

    filterDate (val) {
      if (this.type === 'date') {
        return formatDate(val)
      } else if (this.type === 'time') {
        return formatTime(val)
      } else if (this.type === 'year-month') {
        return format(val, 'YYYY-MM')
      } else if (this.type === 'datetime') {
        if (this.precision === 'hours') {
          return format(val, 'YYYY-MM-DD HH')
        } else {
          return format(val, 'YYYY-MM-DD HH:mm')
        }
      }

      return ''
    },

    showPopup () {
      if (!this.currentTime) {
        this.currentTime = new Date()
      }

      if (this.readonly) {
        return
      }

      this.popupVisible = true
    },
  },
}
